module.exports = __webpack_public_path__ + "static/media/home_icon_shield.7cc96a87.png";